
import * as React from 'react';
import * as PropTypes from 'prop-types'

import Webcam from "react-webcam";

import * as v from '../../global/validation';
import StepHeader from './stepHeader';
import {Customer} from '../../../store/pages/customer/types';
import { clickHandler } from '../../../utils/util';
import NavButtons from './navButtons';

interface RegistrationPhotoProps {
    customer: Customer;
    headerText: string;
    showStep1: () => void;
    cancel: () => void;
    next: (customer: Customer) => void;
}

interface RegistrationPhotoState {
    photographData: string | null;
    error: string | null;
}

const videoConstraints = {
    width: 160,
    height: 214,
    facingMode: "user"
};

class RegistrationPhoto extends React.Component<RegistrationPhotoProps, RegistrationPhotoState> {

    webcamRef = React.createRef<Webcam>();

    constructor(props: RegistrationPhotoProps) {
        super(props);

        this.state = {
            photographData: null,
            error: null
        };
    }

    static contextTypes = {
        t: PropTypes.func
    }

    editCustomer = (e: React.MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();

        this.props.showStep1();
    }

    submit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        if (!v.isValid(this.state)) {
            // TODO: Show error message!
        } else {

            this.props.next({
                ...this.props.customer,
                photographData: this.state.photographData,
            });
        }
    }


    takePicture = () => {
        const webcam = this.webcamRef;
        if (webcam && webcam.current) {
            const imageSrc = webcam.current.getScreenshot();
            this.setState({ photographData: imageSrc });
        }
    }

    cameraError = (err: string | DOMException) => {
        const message = typeof err === 'string' ? err : err.message ? err.message : '';
        this.setState({ error: this.context.t('Registration:cameraError', { err: message }) })
    }

    /*
                                        {({ getScreenshot }) => (
                                            <button
                                                className='btn btn-basic'
                                                style={{ margin: '8px 0' }}
                                                onClick={e => clickHandler(e, () => {
                                                    const imageSrc = getScreenshot()
                                                    console.log(`Captured photo: ${imageSrc}`)
                                                    this.setState({ photographData : imageSrc });
                                                })}>{t('Registration:takePicture')}</button>
                                        )}
     */


    render() {
        const { t } = this.context;
        const { error, photographData } = this.state;

        const photoStyle: React.CSSProperties = { width: videoConstraints.width, height: videoConstraints.height, margin: '0 20px' }

        return (
            <div>
                <form className='registration-form' onSubmit={this.submit} autoComplete='off'>
                    <div style={({ minHeight: '350px' })}>
                        <StepHeader headerText={this.props.headerText} />
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                <Webcam
                                    ref={this.webcamRef}
                                    audio={false}
                                    height={512}
                                    screenshotFormat="image/jpeg"
                                    width={288}
                                    videoConstraints={videoConstraints}
                                    onUserMediaError={this.cameraError} />
                                {photographData ? <img src={photographData} style={photoStyle} /> : <div style={{ ...photoStyle, backgroundColor: '#cccccc' }}></div>}
                            </div>
                            {error ? <div className='alert alert-danger'>{error}</div> : null}
                            <button className='btn btn-basic' style={{ margin: '8px 0' }} onClick={e => clickHandler(e, this.takePicture)}>{t('Registration:takePicture')}</button>
                        </div>
                    </div>
                    <NavButtons t={this.context.t} cancel={this.props.cancel} preventNext={!v.isValid(this.state)} />
                </form>
            </div>
        )
    }
}

export default RegistrationPhoto;